/**
 * Eine feste Farbe je Spieler.
 *
 * Auf dem Fernseher stehen bis zu sechs Zeitleisten untereinander, und
 * bisher unterschieden sie sich ausschliesslich durch den Namenstext.
 * Aus drei Metern ist das nicht lesbar — eine Farbe schon.
 *
 * Aus der Spieler-ID ABGELEITET, nicht vergeben:
 *
 *  - Sie bleibt ueber ein Neuverbinden hinweg gleich. Eine zugewiesene
 *    Farbe muesste im Spielzustand liegen und mitwandern.
 *  - Server und Client kommen unabhaengig auf dasselbe Ergebnis, ohne
 *    dass die Farbe uebertragen werden muss.
 *  - Sie ist ueber Partien hinweg stabil, solange der Spieler dieselbe
 *    ID behaelt.
 */
/**
 * Warme Toene sind fuer Spielbedeutung reserviert, kalte fuer Spieler.
 *
 * Das Designsystem belegt die gesamte warme Haelfte des Farbkreises:
 *
 *   9 Grad   falsch      (--deny)
 *   24 Grad  Aufmerksam  (--accent)
 *   38 Grad  Token       (--token-gold)
 *   101 Grad richtig     (--affirm)
 *   141 Grad Spotify
 *
 * Die erste Fassung dieser Liste enthielt 14, 28 und 48 Grad -- alle
 * drei praktisch deckungsgleich mit "falsch", "Aufmerksamkeit" und
 * "Token". Als kleiner Punkt neben dem Namen faellt das kaum auf; auf
 * einer durchgehenden Zeitleisten-Linie hiesse es "dieser Spieler ist
 * falsch".
 *
 * Deshalb die klare Trennung: warm bedeutet etwas, kalt ist nur wer.
 * Der Nebeneffekt ist erwuenscht -- Spielerfarben treten neben den
 * warmen Signalfarben zurueck statt mit ihnen zu konkurrieren.
 */
const PLAYER_HUES = [
    165, // Tuerkis
    190, // Petrol
    212, // Himmelblau
    235, // Blau
    258, // Indigo
    285, // Violett
    315, // Magenta
    340, // Pink
];
/**
 * Sehr einfacher, stabiler Streuwert (FNV-1a, 32 Bit).
 *
 * Kein Sicherheitsanspruch — es geht nur darum, dass gleiche IDs
 * dieselbe Farbe ergeben und aehnliche IDs ("p1", "p2") nicht
 * benachbart landen.
 */
function hashString(input) {
    let hash = 0x811c9dc5;
    for (let index = 0; index < input.length; index++) {
        hash ^= input.charCodeAt(index);
        hash = Math.imul(hash, 0x01000193);
    }
    return hash >>> 0;
}
/** Farbton in Grad fuer eine Spieler-ID. */
export function playerHue(playerId) {
    const index = hashString(playerId) % PLAYER_HUES.length;
    return PLAYER_HUES[index];
}
/**
 * Fertige Farbe fuer eine Spieler-ID.
 *
 * Saettigung und Helligkeit sind festgelegt, nicht abgeleitet: so
 * bleibt der Kontrast auf dem dunklen Grund fuer alle Spieler gleich
 * gut, egal welcher Ton gezogen wird.
 */
export function playerColor(playerId) {
    return `hsl(${playerHue(playerId)} 62% 62%)`;
}
//# sourceMappingURL=player-color.js.map